import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-embed-block',
  templateUrl: './skeleton-embed-block.component.html',
  styleUrls: ['./skeleton-embed-block.component.scss']
})
export class SkeletonEmbedBlockComponent {}
